import styled from 'styled-components';
import { inputPlaceholder } from '../../helpers/style-helpers';
import theme from '../../constants/theme';

export type TInputSC = {
  mb?: number;
  error?: string | boolean;
};

export const inputBase = `
  display: block;
  width: 100%;
  border: none;
  outline: none;
`;

export const InputSC = styled.div<TInputSC>`
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : `${mb}px`)};

  .input-wrapper {
    display: flex;

    > div {
      padding-left: 16px;
      padding-right: 16px;
      display: flex;
      align-items: center;
      background: ${({ error }) => (error ? '#ffeaee' : theme.colors.inputBg)};
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      width: fit-content;

      label {
        margin-bottom: 0;
        font-size: 14px;
        color: ${({ error }) => (error ? theme.colors.error : '#293157')};
        opacity: 0.6;
        width: max-content;
      }
    }
  }

  input {
    ${inputBase}
    ${({ error }) => inputPlaceholder(error ? theme.colors.error : '#c2c2ce')}

    height: 50px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    background: ${({ error }) => (error ? '#ffeaee' : theme.colors.inputBg)};
    padding-left: 16px;
    color: ${({ error }) => (error ? theme.colors.error : theme.colors.font)};
  }
`;

type TInputLinedSC = {
  error?: string | boolean;
  disabled?: boolean;
};
export const InputLinedSC = styled.div<TInputLinedSC>`
  position: relative;

  input {
    ${inputBase}

    background: transparent;
    height: 40px;
    border-bottom: 1px solid rgba(51, 61, 108, 0.4);
    color: #333d6c;
    font-size: 14px;

    &:active,
    &:hover,
    &:focus {
      border-bottom: 1px solid rgba(51, 61, 108, 1);
    }

    &::-webkit-input-placeholder {
      opacity: 0.4;
      color: ${({ error }) => (error ? theme.colors.error : '#333D6C')};
    }

    &::-moz-placeholder {
      opacity: 0.4;
      color: ${({ error }) => (error ? theme.colors.error : '#333D6C')};
    }

    &:-ms-input-placeholder {
      opacity: 0.4;
      color: ${({ error }) => (error ? theme.colors.error : '#333D6C')};
    }

    &:-moz-placeholder {
      opacity: 0.4;
      color: ${({ error }) => (error ? theme.colors.error : '#333D6C')};
    }

    ${({ disabled }) =>
      disabled
        ? `
        border-color: #D7D9E2;
        color: rgba(24, 30, 52, 0.4);
      `
        : ''}
  }

  .input-lined-img {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 2px 0 rgba(24, 30, 52, 0.1), 0 0 12px 0 rgba(24, 30, 52, 0.15);

    img {
      width: 14px;
      height: 11px;
    }
  }
`;

type TInputLinedGroupSC = {
  isBold?: boolean;
};
export const InputLinedGroupSC = styled.div<TInputLinedGroupSC>`
  display: flex;
  align-items: center;

  label {
    width: 40%;
    font-weight: ${({ isBold }) => (isBold ? '800' : 'bold')};
    font-size: 12px;
    color: rgba(24, 30, 52, 0.5);
    margin-bottom: 0;
  }

  > div {
    width: 60%;
  }
`;
